<template>
  <div class="summary-wrapper">
    <!-- ── barra de totais ── -->
    <div class="summary-header">
      <span class="hdr-total">
        Total: <strong>{{ transactions.length }}</strong> Transações
      </span>
      <span class="hdr-sep">|</span>
      <span class="hdr-pill hdr-approved">
        <span class="dot dot-green"></span>
        Aprovadas: <strong>{{ approvedTransactions.length }}</strong>
      </span>
    </div>

    <!-- ── corpo: cards + pagamentos ── -->
    <div class="summary-body">
      <!-- cards: fluem da esquerda para direita, sem buracos -->
      <div class="cards-section">
        <summary-card
          icon="coins"
          text="Faturamento bruto"
          tooltipText="Soma dos valores dos itens vendidos"
          :value="grossSales"
        />
        <!-- <summary-card
          icon="tag"
          text="Descontos"
          tooltipText="Total de descontos utilizados (cashback + cupons)"
          :value="discounts"
        /> -->
        <!-- <summary-card
          icon="percentage"
          text="Royalties"
          tooltipText="Aplicados sobre o Fat. Líquido"
          :value="royalties"
        /> -->
        <summary-card
          icon="wallet"
          text="Faturamento líquido"
          tooltipText="Fat. Bruto - Descontos"
          :value="netSales"
        />
        <!-- <summary-card
          icon="hand-holding-usd"
          text="Valor a receber"
          tooltipText="A data de pagamento ao licenciado varia de acordo com o método de pagamento utilizado"
          :value="receivable"
        /> -->
        <summary-card
          v-if="permissions.manageBuyNowPayLater"
          icon="file-invoice"
          text="Valor a faturar"
          tooltipText="Transações com status 'A faturar'"
          :value="billingPendingValue"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "../../../mixins/mask";
import summaryCard from "./SummaryCard";

export default {
  props: ["transactions"],

  mixins: [mask],

  components: { summaryCard },

  computed: {
    ...mapGetters(["permissions"]),

    approvedTransactions() {
      return this.transactions.filter(t => t.details.status === "success");
    },

    otherTransactions() {
      return this.transactions.filter(t => t.details.status !== "success");
    },

    billingPendingTransactions() {
      return this.transactions.filter(
        t => t.details.status === "billingPending"
      );
    },

    grossSales() {
      return this.approvedTransactions.reduce(
        (s, t) => s + t.cart.totalValue,
        0
      );
    },

    discounts() {
      return this.approvedTransactions.reduce((s, t) => {
        const cashback = t.discounts?.cashbackUsed || 0;
        const coupon = t.discounts?.coupon?.total || 0;
        return s + cashback + coupon;
      }, 0);
    },

    netSales() {
      return this.grossSales - this.discounts;
    },

    royalties() {
      return parseFloat((this.netSales * 0.1).toFixed(2));
    },

    receivable() {
      return parseFloat((this.netSales - this.royalties).toFixed(2));
    },

    billingPendingValue() {
      return this.billingPendingTransactions.reduce(
        (s, t) => s + t.cart.totalValue,
        0
      );
    }
  }
};
</script>

<style scoped>
/* ── container geral ── */
.summary-wrapper {
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 1.5rem;
}

/* ── barra de totais ── */
.summary-header {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.6rem 1rem;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
  flex-wrap: wrap;
  font-size: 0.82rem;
  color: #444;
}

.hdr-total {
  font-weight: 500;
}

.hdr-sep {
  color: #ccc;
}

.hdr-pill {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.dot-green {
  background: #23c16b;
}
.dot-orange {
  background: #f59e0b;
}

/* ── corpo ── */
.summary-body {
  display: flex;
  gap: 1rem;
  padding: 0.85rem 1rem;
  align-items: flex-start;
}

/* ── grid de cards (flui sem buracos) ── */
.cards-section {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  flex: 1 1 0;
  min-width: 0;
  align-content: flex-start;
}

/* ── responsividade ── */
@media (max-width: 860px) {
  .summary-body {
    flex-direction: column;
  }
}

@media (max-width: 600px) {
  .cards-row {
    flex-direction: column;
  }
}
</style>
